import React, { useRef, useState } from "react";
import styled from "styled-components";
import GeneratedTick from "../../assets/GeneratedCommentTick.svg"
import OnboardingInput from './OnboardingInput';

const OnboardingGeneratedComment = ({ comment, isApproved, onApprove, onEdit }) => {
  const inputRef = useRef(null);

  return (
    <CommentContainer>
      <Label>Your generated comment</Label>

      <div style={{ position: "relative" }}>
        <OnboardingInput
          ref={inputRef}
          value={comment}
          onChange={(e) => onEdit(e.target.value)}
          cutomHandler={true}
          style={{ paddingRight: "40px" }}
          disabled={false} // Always editable
        />
        {isApproved && (
          <CheckIcon onClick={onApprove}>
            <img src={GeneratedTick} alt="Comment-Tick" />
          </CheckIcon>
        )}
      </div>

      {comment !== "Generating Comment..." && (
        <Actions>
          <ActionButton
            onClick={onApprove}
            style={{
              color: isApproved ? "#929292" : "#0450AC",
              borderBottom: `2px solid ${isApproved ? "#929292" : "#0450AC"}`
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="10" fill="currentColor" />
              <path d="M8.95402 14L6 11.2027L7.34619 9.92793L8.95402 11.455L13.6538 7L15 8.27477L8.95402 14Z" fill="white" />
            </svg>
            {isApproved ? "Approved" : "Approve"}
          </ActionButton>
        </Actions>
      )}
    </CommentContainer>
  );
};

export default OnboardingGeneratedComment;

const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 30px 0;
`;

const Label = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0;
`;

const CommentText = styled.span`
  font-family: Open Sans;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
`;

const CheckIcon = styled.span`
  color: ${({ isApproved }) => (isApproved ? "#5bb7e7" : "#ccc")};
  font-size: 16px;
  position: absolute;
  right: 12px;
  top: 19px;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  font-size: 14px;
  color: gray;
  justify-content: center;
`;

const ActionButton = styled.button`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  gap: 6px;
  background: none;
  cursor: pointer;
  color: inherit;
  font-family: "Roboto Slab";
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  vertical-align: middle;
  text-transform: uppercase;
  border-top: none;
  border-right: none;
  border-left: none;
  padding: 1px 0;
  border-image: initial;
  border-bottom: 2px solid #929292;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;
